import api from "./api";
import { generateComment } from "@/mocks/handlers";
// ============ Types ============
export interface Comment {
  comment_id: string;
  reply_id: string;
  comment: string;
  profile: string;
  profile_id: string;
  nickname: string;
  reply_to?: string;
  reply_to_nickname: string | null;
  createAt: string;
  like: number;
  reply_n: number;
  images: Array<{
    url: string;
    width: number;
    height: number;
  }>;
  replies?: Comment[];
}

export interface CommentsResponse {
  comments: Comment[];
  hot_comments: Comment[];
  total: number;
  author_profile_id: string;
  nextCursor?: string;
  hasMore?: boolean;
}

export interface ReplyParams {
  doc_id: string;
  reply: string;
  comment: string;
  source: string;
  operator: string;
  images: any[];
  media_id: number;
  user_id: number;
  profile: string;
  nickname: string;
  [key: string]: any;
}

export interface CommentSuggestion {
  comment: string;
}

// ============ API Functions ============

// Fetch comments for a document
export const fetchComments = async ({
  docid,
  count = 50,
  last_comment_id,
}: {
  docid: string;
  count?: number;
  last_comment_id?: string;
}): Promise<CommentsResponse> => {
  return api.get(`/contents/comments`, {
    params: {
      hot_comment: true,
      docid,
      count,
      last_comment_id,
    }
  });

};

// Reply to a comment
export const postCommentService = async (params: any): Promise<Comment> => {
  const comment = encodeURIComponent(params.comment);
  return api.post(`/interact/add-comment?docid=${params.docid}&comment=${comment}`, params);
};
export const replyCommentService = async (params: any): Promise<Comment> => {
  const comment = encodeURIComponent(params.comment);
  return api.post(`/interact/add-comment?docid=${params.docid}&comment=${comment}&reply=${params.reply}`, params);
};

// Fetch replies for a specific comment
export const fetchCommentReplies = async (params: any): Promise<{ comment: { replies: Comment[] } }> => {
  return api.get(`/contents/comment-replies`, { params });
};

// Like/unlike a comment
export const toggleCommentLike = async (
  commentId: string
): Promise<{
  liked: boolean;
  likeCount: number;
}> => {
  return api.post(`/comments/${commentId}/like`);
};

// Delete a comment
export const deleteCommentService = async (params: any): Promise<void> => {
  return api.get(`/interact/del-comment`, { params });
};
export const likeCommentService = async (params: any): Promise<void> => {
  return api.post(`/interact/like-comment?comment_id=${params.comment_id}`, params);
};
export const dislikeCommentService = async (params: any): Promise<void> => {
  return api.get(`/interact/dislike-comment`, { params });
};
